import K8ReportingGradeTile from './component'
export default K8ReportingGradeTile
